import { ReactComponent as EditActionSvg } from "../../assets/images/svgs/editAction.svg";

const EditActionIcon = ({ className = "", ...props }) => {
  return (
    <EditActionSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default EditActionIcon;
